import { Button, Icon, Popconfirm } from 'antd'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form';
import { required } from 'redux-form-validators';
import InputField from '../../../../../../../../../helpers/Fields/InputField';
import { createLabel, deleteLabel, updateLabel } from '../../../../actions';
import FieldColor from './components/FieldColor/FieldColor';

export class FormLabel extends Component {

  constructor(props) {
    super(props)
  
    this.state = {
       loaded: true
    }
  }
  
  submit = async (values) => {
    this.setState({loaded: false})
    if(values.id){
      await this.props.updateLabel(values);
    } else {
      await this.props.createLabel(values);
    }
    this.setState({loaded: true})
    this.props.onClose()
  }

  render() {
    const {handleSubmit, formatMessage, initialValues} = this.props;
    const {loaded} = this.state;
    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <Field component={InputField} name="text" label={formatMessage('labelTitle')} validate={[]} />
        <Field component={FieldColor} name="color" label={formatMessage('labelColor')} validate={[required()]} />
       
        <Button loading={!loaded} htmlType='submit' type='primary' style={{marginBottom: 10}} block>{formatMessage('saveLabel')}</Button>
        {initialValues && initialValues.id && 
          <Popconfirm
            title={formatMessage('deleteLabelMessage')}
            onConfirm={() => {
              this.props.deleteLabel(initialValues.id)
              this.props.onClose()
            }}
            okText="Yes"
            cancelText="No"
          >
            <Button type='danger' style={{marginBottom: 10}} block>{formatMessage('deleteLabel')}</Button>
          </Popconfirm>
        }
        <Button block onClick={() => this.props.onClose()}>{formatMessage('btnBack')}</Button>
    
      </form>
    )
  }
}

const FormContentData = reduxForm({
  form: 'form_label',
  enableReinitialize: true,
})(FormLabel);

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {
  createLabel,
  deleteLabel,
  updateLabel,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContentData)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/QuestionForm/components/Labels/components/FormData/components/FormLabel/FormLabel.jsx